import { Modal } from "flowbite-react";
import { useToastContext } from "../../../../../../../common/components/ui/toast/toast.context";
import { ConvertDepositType, PaymentInfo } from "../../../../../../../types/payment.type";
import { convertDeposit } from "../../../../../../../common/services/payments.api";
import FormConvertDeposit from "../form/FormConvertCaucao";

type Props = {
  payments: PaymentInfo[];
  renterId: string;
  onClose: () => void;
}

export default function ModalConvertDeposit(props: Props) {
  const { notifySuccess, notifyError } = useToastContext();
  const handleCloseModal = () => { props.onClose(); };

  async function convertDepositSave(dataDepositConvert: ConvertDepositType) {

    const result = await convertDeposit(dataDepositConvert);

    if (result.ok) {
      notifySuccess('Pagamento removido com sucesso!');
    }

    if (!result.ok) {
      notifyError(result.message as string)
    }
  }



  return (
    <Modal
      className='relative dark:text-black'
      show={true}
      onClose={() => handleCloseModal()}
    >
      <Modal.Header>
        <h2 className="text-black text-lg font-semibold">
          Convertendo Caução
        </h2>
      </Modal.Header>
      <Modal.Body>
        <FormConvertDeposit
          payments={props.payments}
          renterId={props.renterId}
          onClose={handleCloseModal}
          onSubmit={convertDepositSave}
        />
      </Modal.Body>

    </Modal>
  )
}